module.exports = __webpack_public_path__ + "static/img/ic_error.af6fe29.png";